module.exports = __webpack_public_path__ + "icon_team_gray.71441.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/icon_team_gray.svg
// module id = ./src/_asset/sources/assets/images/@svg/icon_team_gray.svg
// module chunks = main